import EventActionProto from 'core/gd-session/event-action-proto';

module.exports = class SessionMeetingUpdate extends EventActionProto {

    constructor(uid, data, sid, companyId, sessionEvent) {
        super(sessionEvent.uid, sessionEvent.data, sessionEvent.companyId)
        this.method     = sessionEvent.method
        this.header     = {
            meeting     : sessionEvent.data,
            isBulkUpdate: sessionEvent.isBulkUpdate,
        }
        this.fromSID    = sessionEvent.fromSID
    }

    process() {
        const meetingId = this.data.id;

        // here we do 2 this
        // - update gd.session.meetings
        // - translate this event via bus so you get the update if needed i.e. have meeting open

        // session
        if (gd.session.meetings) {
            gd.session.meetings.update(meetingId, this.data);
        }

        gd.modelBus.newUpdate('meeting', 'delta', this.header.meeting.id, this.data, this.header)

        // at least recurrence update is triggered by 'meeting.{0}:update' event below
        /*// do not process event for user who initialed update
        if (this.fromSID === gd.sessionId) {
            // console.log("same user -> ignore");
            return false;
        }*/

        // Bus event triggers

        // don't this we need it - question is how we update in my work.... but let's think later
        // skoree my work dolzen slushat' events from gd.session.meeting...
        // etot podhod dlya tasks mozet bit' good dlya meetings ne to nemnogo...
        // gd.bus.triggerEvent('meeting:update', {data: this.data});

        // event name = meeting.MEETING-ID:update
        gd.bus.triggerEvent('meeting.{0}:update'.f(meetingId), this.data);

        super.process();
    }
};

